import "./style.css"
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Typography, Row, Col, Button, Card, Spin } from "antd";
import { getDcRateHistory } from "../../../../actionCreators/Property";

function DcRateHistory({
	user,
	getDcRateHistory,
	dcRateHistory
}) {
	const history = useHistory();
	
	const [isDistrictAdmin] = useState(user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id === 5) >=
  0 ? true : false);

	useEffect(() => {
		
    getDcRateHistory({ id: history.location.state?.valuation_classification_id })
  }, [history.location.state]);
	
	return(
		<div>
			<div>
				<Typography className="heading">Dc Rate History</Typography>
			</div>
			<div className="history-contenct-wrapper">
				{ dcRateHistory?.data?.data && dcRateHistory?.data?.data?.map?.((history) => {
					return (
						<div className="history-content">
							<div className="history-event-info">
								<div>
									<span>Event Type: {history?.eventType}</span>
								</div>
								{!isDistrictAdmin && <div>
									<span>Performed By: {history?.userName}</span>
								</div>}
							</div>
							<div className="history-data">
								<div className="history-data-content">
									<div style={{ fontSize: "16px", fontWeight: "bold" }} >Old Data</div>
									{ history?.oldData && (
										<div>
											{ (history?.oldData?.KhasraName || history?.oldData?.['Khasra Number'])  && 
												<p>Khasra Number: {history?.oldData?.KhasraName ?? history?.oldData?.['Khasra Number']}</p> 
											}
											{ (history?.oldData?.dc_rate || history?.oldData?.['Dc Rate']) && 
												<p>Dc Rate: {history?.oldData?.dc_rate ?? history?.oldData?.['Dc Rate']}</p> 
											}
											{ (history?.oldData?.structure_rate || history?.oldData?.['Structure Rate']) && 
												<p>Structure Rate: {history?.oldData?.structure_rate ?? history?.oldData?.['Structure Rate']}</p> 
											}
											{ (history?.oldData?.effects_from || history?.oldData?.effect_from) && 
												<p>Effected From: {history?.oldData?.effects_from ?? history?.oldData?.effect_from }</p>
											}
										</div>	
									)}
								</div>
								<div className="history-data-content">
									<div style={{ fontSize: "16px", fontWeight: "bold" }}>New Data</div>
									{ history?.newData && (
										<div>
											{ history?.newData?.KhasraName && 
												<p>Khasra Number: {history?.newData?.KhasraName}</p> 
											}
											{ (history?.newData?.dc_rate || history?.newData?.dcRate) && 
												<p>Dc Rate: {history?.newData?.dc_rate ?? history?.newData?.dcRate}</p> 
											}
											{ (history?.newData?.structure_rate || history?.newData?.structureRate) && 
												<p>Structure Rate: {history?.newData?.structure_rate ?? history?.newData?.structureRate}</p> 
											}
											{ (history?.newData?.effects_from || history?.newData?.effectFrom) && 
												<p>Effected From: {history?.newData?.effects_from ?? history?.newData?.effectFrom }</p> 
											}
										</div>	
									)}
								</div>
							</div>
						</div>
					)
				}) 
			}
			</div>
		</div>
	)
}

const mapStateToProps = ({
  user: user,
  property: { dcRateHistory },
}) => ({
  user,
  dcRateHistory,
});

const mapDispatchToProps = (dispatch) => ({
  getDcRateHistory: bindActionCreators(getDcRateHistory, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DcRateHistory);